// extracted by mini-css-extract-plugin
export var label = "_ft-2";
export var slideContainer = "_ft-0";
export var slider = "_ft-1";